import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export interface IPlanStore {
	username: string
	usersPreferredName: string
	companyId: string
	contractId: string
	memberId: string
	memberSeqNumber: string
	isPolicyHolder: boolean
	isActive: boolean
	contractType: string
	origEffDate: string
	covTermDate: string
	lobDisplayName: string
	tier1: string
	ssoType: string
	displayName: string
}

export const useSelectedPlanStore = defineStore(
	'selectedPlanStore',
	() => {
		// ====---------------====
		// 🗄️ State
		// ====---------------====
		const defaultState = {
			username: '',
			usersPreferredName: '',
			companyId: '',
			contractId: '',
			memberId: '',
			memberSeqNumber: '',
			isPolicyHolder: false,
			isActive: false,
			contractType: '',
			origEffDate: '',
			covTermDate: '',
			lobDisplayName: '',
			tier1: '',
			ssoType: '',
			displayName: ''
		}
		const state = reactive<IPlanStore>({ ...defaultState })
		const loaded = ref(false)

		// ====---------------====
		// 🏃‍♂️ Getters
		// ====---------------====
		function getStore() {
			return state
		}

		function getLobName() {
			switch (state.tier1) {
				case 'HA':
					return 'Health Advantage '
				case 'BA':
					return 'BlueAdvantage Administrators of Arkansas '
				case 'ABCBS':
					return 'Arkansas Blue Cross and Blue Shield '
				case 'ABM':
					return 'Arkansas Blue Medicare '
				case 'OCTAVE':
					return 'Octave'
				default:
					return 'Arkansas Blue Cross and Blue Shield '
			}
		}

		// ====---------------====
		// 🎬 Actions
		// ====---------------====
		function setupStore(plan: IPlanStore) {
			Object.keys(plan).forEach((key) => {
				state[key] = plan[key]
			})
			loaded.value = true
		}

		function $reset() {
			Object.keys(state).forEach((key) => {
				delete state[key]
			})
			loaded.value = false
		}

		// ====---------------====
		// 🚀 Exports
		// ====---------------====
		return {
			state,
			loaded,
			getLobName,
			getStore,
			setupStore,
			$reset
		}
	},
	{
		persist: {
			storage: sessionStorage
		}
	}
)
